/**
 * Cinematic hero scene artwork.
 * Source files: src/assets/sence1.png … sence7.png
 * Served from: public/assets/logistics-story/scenes/scene-XX-*.png
 * After replacing src/assets/senceN.png run: node scripts/sync-scene-assets.js N
 *
 * Desktop @2x (3344px wide) lives beside each scene-XX-*.png file.
 */

const BASE = `${process.env.PUBLIC_URL || ""}/assets/logistics-story/scenes`;
const DESKTOP_V = "v=11";
const MOBILE_V = "v=5";
const MOBILE_W = 529;
const MOBILE_2X_W = 1058;
const DESKTOP_W = 1672;
const DESKTOP_2X_W = 3344;

export const SCENE_IMAGES = {
  1: `${BASE}/scene-01-wide.png?${DESKTOP_V}`,
  3: `${BASE}/scene-03-importer.png?${DESKTOP_V}`,
  4: `${BASE}/scene-04-corridor.png?${DESKTOP_V}`,
  7: `${BASE}/scene-07-provider-poster.png?${DESKTOP_V}`,
  5: `${BASE}/scene-05-provider.png?${DESKTOP_V}`,
  6: `${BASE}/scene-06-finale.png?${DESKTOP_V}`,
};

/** Retina / HiDPI laptop & desktop */
export const SCENE_IMAGES_2X = {
  1: `${BASE}/scene-01-wide@2x.png?${DESKTOP_V}`,
  3: `${BASE}/scene-03-importer@2x.png?${DESKTOP_V}`,
  4: `${BASE}/scene-04-corridor@2x.png?${DESKTOP_V}`,
  7: `${BASE}/scene-07-provider-poster@2x.png?${DESKTOP_V}`,
  5: `${BASE}/scene-05-provider@2x.png?${DESKTOP_V}`,
  6: `${BASE}/scene-06-finale@2x.png?${DESKTOP_V}`,
};

/** Portrait 9:16 center crops — mobile screens */
export const SCENE_IMAGES_MOBILE = {
  1: `${BASE}/scene-01-mobile.png?${MOBILE_V}`,
  3: `${BASE}/scene-03-mobile.png?${MOBILE_V}`,
  4: `${BASE}/scene-04-mobile.png?${MOBILE_V}`,
  7: `${BASE}/scene-07-mobile.png?${MOBILE_V}`,
  5: `${BASE}/scene-05-mobile.png?${MOBILE_V}`,
  6: `${BASE}/scene-06-mobile.png?${MOBILE_V}`,
};

/** Retina companions for mobile crops */
export const SCENE_IMAGES_MOBILE_2X = {
  1: `${BASE}/scene-01-mobile@2x.png?${MOBILE_V}`,
  3: `${BASE}/scene-03-mobile@2x.png?${MOBILE_V}`,
  4: `${BASE}/scene-04-mobile@2x.png?${MOBILE_V}`,
  7: `${BASE}/scene-07-mobile@2x.png?${MOBILE_V}`,
  5: `${BASE}/scene-05-mobile@2x.png?${MOBILE_V}`,
  6: `${BASE}/scene-06-mobile@2x.png?${MOBILE_V}`,
};

export function getSceneImageProps(id, breakpoint) {
  if (breakpoint === "mobile" && SCENE_IMAGES_MOBILE[id]) {
    const src = SCENE_IMAGES_MOBILE[id];
    const src2x = SCENE_IMAGES_MOBILE_2X[id];
    return {
      imageSrc: src,
      imageSrcSet: src2x
        ? `${src} ${MOBILE_W}w, ${src2x} ${MOBILE_2X_W}w`
        : undefined,
      imageSizes: "100vw",
    };
  }

  const src = SCENE_IMAGES[id];
  const src2x = SCENE_IMAGES_2X[id];
  return {
    imageSrc: src,
    imageSrcSet: src2x
      ? `${src} ${DESKTOP_W}w, ${src2x} ${DESKTOP_2X_W}w`
      : src
        ? `${src} ${DESKTOP_W}w`
        : undefined,
    imageSizes: "100vw",
  };
}

/** Ordered scene ids for the single GSAP timeline */
export const SCENE_IDS = [1, 3, 4, 7, 5, 6];

export const SCROLL_CONFIG = {
  desktop: { totalVh: 640 },
  tablet: { totalVh: 500 },
  mobile: { totalVh: 350 },
};

/**
 * Per-scene camera hints used by the timeline.
 * scale/x/y describe the image layer motion while the scene is active.
 */
export const SCENE_CAMERA = {
  1: { scale: 1, x: 0, y: 0 },
  3: { scale: 1, x: 0, y: 0 },
  4: { scale: 1, x: 0, y: 0 },
  7: { scale: 1, x: 0, y: 0 },
  5: { scale: 1, x: 0, y: 0 },
  6: { scale: 1, x: 0, y: 0 },
};
